// src/pages/Financial.tsx
import { Box, Typography } from "@mui/material";
import withAuth from "../../HOC/withAuth";

const Financial = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        py: 8,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: 900,
          fontSize: { xs: "32px", md: "56px" },
          color: "#0021F5",
          mb: 3,
        }}
      >
        Case Study Coming Soon
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          maxWidth: "600px",
          mb: 5,
          lineHeight: 1.6,
        }}
      >
        I recently worked on onboarding flows for a financial trading app with
        over <strong>30M+ users</strong>, driving a{" "}
        <strong>30% lift in conversion</strong>.  
        A full case study is in progress — stay tuned!
      </Typography>

      <Box
        sx={{
          px: 4,
          py: 1.5,
          border: "3px solid #000",
          background: "#fff",
          fontWeight: 800,
          textTransform: "uppercase",
          fontSize: "16px",
          color: "#0021F5",
        }}
      >
        Coming Soon
      </Box>
    </Box>
  );
};

export default withAuth(Financial);
